var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldStages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 140,
    viewBox: "0 0 103 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 8.72363,
    width: 101.509,
    height: 131.276,
    fill: "url(#paint0_linear_10204_4294)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7376 0.18457H87.7164L102.481 8.72285H0.972656L15.7376 0.18457Z",
    fill: "#8AD370"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5795 105.412C62.5795 106.389 62.368 107.072 61.9448 107.463C61.5542 107.821 60.8706 108 59.894 108H49.8354C48.8588 108 48.159 107.821 47.7358 107.463C47.3452 107.072 47.1499 106.389 47.1499 105.412V54.2891L40.3627 57.707C39.7117 58.0651 39.1258 58.2116 38.6049 58.1465C37.5958 57.9837 36.489 57.7233 35.2846 57.3652C34.1127 57.0072 32.8107 56.5189 31.3784 55.9004C30.8901 55.6074 30.5971 55.347 30.4995 55.1191C30.3693 54.8913 30.3693 54.5169 30.4995 53.9961C31.2482 51.1315 32.1433 48.7878 33.185 46.9648C33.5105 46.5091 33.9825 46.1348 34.601 45.8418L53.2534 36.418H62.5795V105.412Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10204_4294",
    x1: 51.727,
    y1: 8.72363,
    x2: 51.727,
    y2: 101.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33D00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#286513"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldStages);
export default __webpack_public_path__ + "static/media/goldStages.4b3c9898b9db6882a46ce22ffb413b1d.svg";
export { ForwardRef as ReactComponent };